export const KeycloakTokenConfig = Object.freeze({
  keycloakStorage: {
    kcToken: 'kc_token',
    kcRefreshToken: 'kc_refreshToken',
  },
});
